import React, { useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";

export default function ResetPassword({ tempToken, onNext }) {
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  const handleReset = async (e) => {
    e.preventDefault();
    if (password.length < 6) return toast.error("Password too short.");
    if (password !== confirm) return toast.error("Passwords do not match.");

    setLoading(true);
    try {
      const res = await axios.post("https://globisun-app.onrender.com/api/auth/reset-password", {
        token: tempToken,
        password,
      });
      toast.success(res.data.msg || "Password reset successful!");
      onNext(1); // redirect to step 1 (login or forgot)
    } catch (err) {
      toast.error(err.response?.data?.msg || "Failed to reset password.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="forgot-step">
      <h2>Reset Password</h2>
      <p>Enter your new password below.</p>
      <form onSubmit={handleReset}>
        <input
          type="password"
          placeholder="New password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          disabled={loading}
        />
        <input
          type="password"
          placeholder="Confirm password"
          value={confirm}
          onChange={(e) => setConfirm(e.target.value)}
          required
          disabled={loading}
        />
        <button type="submit" disabled={loading}>
          {loading ? "Resetting..." : "Reset Password"}
        </button>
      </form>
    </div>
  );
}
